import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UserDto } from '@common/generated-api/models/user-dto';
import { AppModes, AppService } from '@shared/services/app.service';
import { MessageHelperService } from '@shared/services/message-helper.service';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';

export interface IAuthData {
  token: string;
  isLoggedIn: boolean;
  notUpdateLS?: boolean;
  companyType: AppModes;
  userId: number;
  user: UserDto;
}

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  authToken: string;
  private authData = new BehaviorSubject<IAuthData>({
    isLoggedIn: false,
    token: null,
    notUpdateLS: true,
    companyType: null,
    userId: null,
    user: null,
  });
  authData$ = this.authData.asObservable();

  constructor() {} // private router: Router,

  getAuthData() {
    return this.authData.getValue();
  }

  setLoggedIn(authData: IAuthData, notUpdateLS = false) {
    this.authData.next({ ...authData, notUpdateLS });
  }

  setLoggedOut() {
    this.authData.next({ isLoggedIn: false, token: null, companyType: null, userId: null, user: null });
  }

  // private navigateToLoginPage() {
  //   this.router.navigateByUrl('auth').then();
  // }
}
